module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/radio-group/radio-group.component.html
// module id = ./src/app/modules/base-module/components/radio-group/radio-group.component.html
// module chunks = 9